import 'react-modern-calendar-datepicker/lib/DatePicker.css'
import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Select from 'react-select'
import DatePicker from 'react-modern-calendar-datepicker'
import Store from '../store/ProductionTableStore'
import { datepickerLocale } from '../../../helpers'

@observer
class TableFilter extends Component {
    selectStyle = {
        option: (provided) => ({
            ...provided,
            color: 'black',
        }),
        control: (provided) => ({
            ...provided,
            height: '42px'
        })
    }

    datepickerFooter = () => {
        return <div className="DatePicker__footer">
            <ul className="DatePicker__footer__default">
                <li
                    className={ `DatePicker__footer__default__item ${ Store.dateRange.type === 'weeks' ? 'DatePicker__footer__default__item--active' : '' }` }
                    onClick={ Store.HANDLE_SET_RANGE_DEFAULT.bind(this, 'weeks', true) }
                >
                    1 Vecka
                </li>
                <li
                    className={ `DatePicker__footer__default__item ${ Store.dateRange.type === 'months' ? 'DatePicker__footer__default__item--active' : '' }` }
                    onClick={ Store.HANDLE_SET_RANGE_DEFAULT.bind(this, 'months', true) }
                >
                    1 Månad
                </li>
            </ul>
            <button
                className="DatePicker__footer__btn"
                onClick={ Store.HANDLE_RESET_DATEPICKER }
            >
                Nollställ
            </button>
        </div>
    }

    render() {
        const selectFilters = []

        for (const filter in Store.filters.selects) {
            const filterLoading = Store.filters.filterLoading
            let filterState = Store.filters.selects[filter]
            const placeholder = filterLoading ? filterState.loadingText : filterState.placeholder

            selectFilters.push(
                <div className="table-filter__inner__item" key={ `filter-${ filter }` }>
                    <Select
                        className="table-filter__inner__item__select"
                        closeMenuOnSelect={ true }
                        isSearchable={ true }
                        options={ filterState.options }
                        styles={ this.selectStyle }
                        value={ filterState.selected }
                        placeholder={ placeholder }
                        onChange={ Store.FETCH_ORDERS_ASYNC }
                        isLoading={ filterState.filterLoading }
                        isDisabled={ filterState.filterLoading }
                    />
                </div>
            )
        }

        return <div className="table-filter">
            <div className="table-filter__inner">
                { selectFilters }

                <div className="table-filter__inner__item">
                    <button onClick={ Store.HANDLE_RESET_FILTER } className="pt-btn pt-btn--danger">
                        Rensa filtrering
                    </button>
                </div>
            </div>

            <div className="table-filter__inner">
                            <div className="table-filter__inner__range">
                    <DatePicker
                        onChange={ Store.HANDLE_DATE_RANGE }
                        locale={ datepickerLocale.sv }
                        inputPlaceholder="Filtrera på datumintervall"
                        value={ Store.dateRange }
                        renderFooter={ this.datepickerFooter }
                    />
                </div>
            </div>
        </div>
    }
}

export default TableFilter;
